var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-header-left"},[_c('div',{staticClass:"btn",on:{"click":_vm.PDLClick}},[_c('i',{staticClass:"fas",class:_vm.PDLIcon}),_vm._v(" "),_c('span',{staticClass:"btn-txt"},[_vm._v(_vm._s(_vm.PDLLink))]),_vm._v(" "),(_vm.PDLBadge)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.PDLBadge))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404d79f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompHeaderLeft.vue
// module id = null
// module chunks = 